<template lang="pug">
    div
        div.width-100-percent.pa-md-5(v-if="validCustomer")
            BaseCustomerProfile(
                :customer-id="customerID"
                source="communication_center"
                :exit="exit"
            )

        v-card(v-show="!validCustomer")
            ConversationGroupIndex(
                v-show="selectedView === 'conversation-groups'"
                :current-navigation="currentNavigation"
                :cg-acknowledged-from-msg-screen="cgAcknowledgedFromMsgScreen"
                group-type="customer_to_caller_id"
                :enter-manual-mode="enterManualMode"
                :force-organization-users="organizationUsers"
                :source="source"
                :space-ratio="spaceRatio"
            )
            MessageIndex(
                v-show="selectedView === 'messages'"
                :current-navigation="currentNavigation"
                :force-organization-users="organizationUsers"
                :offset-top="offsetTop"
                :selected-view="selectedView"
                :source="source"
                :view-profile="viewProfile"
            )

            v-speed-dial(v-model='fab' top left direction='bottom' style="margin-top: 18px; margin-bottom: 75px;" absolute open-on-hover transition='slide-y-reverse-transition')
                template(v-slot:activator)
                    v-btn(v-model='fab' color='blue' dark fab small)
                        v-icon(v-if='fab')
                            | mdi-close
                        v-icon(v-else)
                            | mdi-swap-horizontal
                v-btn(fab dark small color='blue' @click="selectedView = 'conversation-groups';")
                    v-tooltip(right)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-cellphone
                        span
                            | vMessage

                v-btn(fab dark small color='blue' @click="selectedView = 'messages';")
                    v-tooltip(right)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-magnify
                        span
                            | Message Search

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import BaseCustomerProfile from '@/components/customers/base_customer_profile.vue';
    import ConversationGroupIndex from '@/components/conversation_groups/index.vue';
    import MessageIndex from '@/components/messages/index.vue';

    export default Vue.extend({
        data() {
            return {
                customerID: null,
                fab: false,
                offsetTop: 0,
                selectedView: "conversation-groups",
            }
        },
        methods: {
            createAgentForVMessage() {
                if (!this.validCreateAgent) {
                    return;
                }

                const options = {
                    status_name: "vMessage",
                }

                this.createAgent(options);
            },
            exit() {
                this.customerID = null;
            },
            prepareSelectedView() {
                switch(this.selectedView) {
                case "conversation-groups":
                    this.setHtmlOverflow("hidden");
                    break;
                case "messages":
                    // this.setHtmlOverflow("scroll");
                    break;
                }
            },
            setHtmlOverflow(value) {
                const htmlTag = document.getElementsByTagName('html')[0];
                if (!!htmlTag) {

                    // remove tags
                    htmlTag.classList.remove('overflow-y-hidden');
                    htmlTag.classList.remove('overflow-y-scroll');

                    // If hidden, need to scroll back to top
                    if (value === "hidden") {
                        window.scrollTo(0, 0);
                        htmlTag.classList.add('overflow-y-hidden');

                    } else if(value === "scroll"){
                        htmlTag.classList.add('overflow-y-scroll');
                    }
                }
                return;
            },
            viewProfile(customerID, offsetTop) {
                this.customerID = customerID;
                this.offsetTop = offsetTop;
            },
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            paddingClass() {
                return this.validCustomer ? null : "pa-md-5";
            },
            validCreateAgent() {
                return this.createAgent !== undefined && this.createAgent !== null;
            },
            validCustomer() {
                return this.customerID > 0;
            },
        },
        components: {
            BaseCustomerProfile,
            ConversationGroupIndex,
            MessageIndex,
        },
        props: {
            createAgent: Function,
            currentNavigation: String,
            cgAcknowledgedFromMsgScreen: Boolean,
            enterManualMode: Function,
            organizationUsers: Array,
            source: String,
            spaceRatio: Number,
        },
        watch: {
            currentNavigation() {
                // Will happen the 2nd time on when coming to this screen because of the show
                if (this.currentNavigation === "v_message") {
                    this.createAgentForVMessage();
                    this.prepareSelectedView();
                }
            },
            "customerID"() {
                if (!this.validCustomer) {
                    this.setHtmlOverflow("scroll");
                }
            },
            "selectedView"() {
                this.prepareSelectedView();
            },
        },
        created() {
            this.createAgentForVMessage();
        },
    });
</script>

<style lang="scss" scoped>
</style>
